// extracted by mini-css-extract-plugin
export default {"resume":"src_resume__W8k5X","work":"src_work__9-4OZ"};